import OItemsSortingOtg from './o-items-sorting-otg.vue';

export default OItemsSortingOtg;